import { Controller } from "@hotwired/stimulus"
import { readCookie, setCookie } from "modules/cookie_helpers"
import localStore from "../modules/local_store"

export default class extends Controller {
  static targets = [
    "columnList",
    "search"
  ];

  connect() {
    this.savedViewId = this.queryParams.get('saved_view_id');
    this.tableName   = this.element.closest('turbo-frame').id;
    this.shortHands  = this.element.querySelector('.short-hands');

    this.updateColumnsCount();
    this.sortColumns();
  }

  ///////////////
  /// Actions ///
  ///////////////

  updateColumnsCount() {
    const panelTitle = this.element.querySelector('.panel-heading > span');
    if (!panelTitle) return;

    const totalCount    = this.columnListTarget.querySelectorAll('input[type="checkbox"]').length;
    const selectedCount = this.columnListTarget.querySelectorAll('input[type="checkbox"]:checked').length;

    panelTitle.innerHTML = `${panelTitle.textContent.replace(/\s*\(\d+\/\d+\)$/, '')} (${selectedCount}/${totalCount})`;
  }

  sortColumns() {
    const columns           = Array.from(this.columnListTarget.querySelectorAll('li'));
    const selectedColumns   = columns
      .filter(li => li.querySelector('input[type="checkbox"]')?.checked)
      .sort((a, b) => {
        const aOrder = a.querySelector('input[type="checkbox"]').dataset.order;
        const bOrder = b.querySelector('input[type="checkbox"]').dataset.order;
        return aOrder - bOrder;
      });

    const unselectedColumns = columns
      .filter(li => li.querySelector('input[type="checkbox"]')?.checked === false)
      .sort((a, b) => {
        const aText = a.textContent.toLowerCase();
        const bText = b.textContent.toLowerCase();
        return aText.localeCompare(bText);
      });

    this.columnListTarget.innerHTML = "";
    selectedColumns.forEach(column => this.columnListTarget.appendChild(column));

    if (unselectedColumns.length > 0) {
      this.columnListTarget.insertAdjacentHTML('beforeend', '<li class="dropdown-header">All Columns</li>');
      unselectedColumns.forEach(column => this.columnListTarget.appendChild(column));
    }
  }

  searchColumns() {
    const query = this.searchTarget.value.toLowerCase();

    if (this.shortHands) {
      this.shortHands.style.display = query === '' ? '' : 'none';
    }

    this.columnListTarget
      .querySelectorAll('li')
      .forEach(li => {
        const legit   = li.querySelector('input[type="checkbox"]')
        const matches = li.textContent.toLowerCase().includes(query)

        li.style.display = (legit && matches) || (!legit && query === '')
          ? ''
          : 'none';
      });
  }

  selectAllColumns(event) {
    event.preventDefault();

    this.columnListTarget
      .querySelectorAll("input[type='checkbox']")
      .forEach(input => {
        input.checked = true;
      });
  }

  selectDefaultColumns(event) {
    event.preventDefault();

    this.columnListTarget
      .querySelectorAll("input[type='checkbox']")
      .forEach(input => {
        input.checked = input.dataset.default === "true";
      });
  }

  clearAllColumns(event) {
    event.preventDefault();

    this.columnListTarget
      .querySelectorAll("input[type='checkbox']")
      .forEach(input => {
        input.checked = false;
      });
  }

  async saveCurrentView(event) {
    event.preventDefault();

    let cookieKey = `${this.tableName}-columns`
    if (this.savedViewId) cookieKey += `-${this.savedViewId}`

    setCookie(cookieKey, this.selectedColumns);

    $(this.element).find('a.dropdown-toggle').dropdown('toggle');
    // localStore.remove(`rtc/${this.tableName}`);

    Turbo.visit(window.location.href, { frame: this.tableName });
  }

  get selectedColumns() {
    return Array.from(this.columnListTarget.querySelectorAll('input:checked'))
      .sort((a, b) => {
        return a.dataset.order - b.dataset.order;
      })
      .map(input => input.dataset.column)
      .join(',');
  }

  get queryParams() {
    return new URLSearchParams(window.location.search);
  }
}
